import classnames from 'classnames'
import { FC, SyntheticEvent } from 'react'

import { useProductWishList } from '@src/hooks/useProductWishlist'
import { IconButton } from '@src/quince-components/src'

import DeleteIcon from '../../icons/delete.inline.svg'
import { CardVariant } from '../../product-card.types'

import styles from './delete-wishlist.module.scss'

export const ProductCardDeleteFromWishlist: FC<{
  shopifyProductId: string | number
  selectedCardVariant?: CardVariant
  deleteItemClassName?: string
  wishlistTrackingConfig: Record<string, unknown>
}> = props => {
  const selectedColor = props.selectedCardVariant?.displayConfig.value

  const { removeItemFromWishList } = useProductWishList()

  const onWishListToggle = (event: SyntheticEvent) => {
    event.preventDefault()
    event.stopPropagation()

    removeItemFromWishList(props.shopifyProductId as number, selectedColor ?? '', props.wishlistTrackingConfig).catch(
      (e: unknown) => {
        console.error(e)
      },
    )
  }

  return (
    <IconButton
      className={classnames(props.deleteItemClassName, styles.defaultButton)}
      iconClassName={classnames(styles.icon)}
      iconSvg={DeleteIcon}
      onClick={onWishListToggle}
      ariaLabel={'Remove from wishlist'}
    />
  )
}
